var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "14px",
    viewBox: "0 0 25 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FCE55F8D-ACBA-4BAA-AE35-A8D399FDFD81@1.5x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Schools/Web-Player",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Schools/Lessons/SEL",
    transform: "translate(-1062.000000, -354.000000)",
    stroke: "#05073c80",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "choose-content",
    transform: "translate(757.500000, 333.500000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    transform: "translate(305.000000, 15.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.905947029,6.22806276 L11.8839888,17.8156791 M22.8839888,6.22806276 L11.905947,17.8156791"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.4db4e2ea1fb77453ab90bcb8c1f997c6.svg";
export { ForwardRef as ReactComponent };